import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
} from '@mui/material';
import { SVButton } from '../core';
import {
  useCancelWireRecipientRequest,
  useDeleteWireRecipient,
} from '@/hooks/requests/useWireRecipients';
import showToast from '@/utils/toast';
import { MESSAGES } from '@/constants/messages';

type WireRecipientDeleteCancelDialogProps = {
  uuid: string;
  name: string;
  isDelete: boolean;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function WireRecipientDeleteCancelDialog({
  uuid,
  name,
  isDelete,
  open,
  setOpen,
}: WireRecipientDeleteCancelDialogProps) {
  const { deleteWireRecipient, isDeleteWireRecipientPending } =
    useDeleteWireRecipient(uuid);
  const { cancelWireRecipient, isCancelWireRecipientPending } =
    useCancelWireRecipientRequest(uuid);
  const isLoading =
    isCancelWireRecipientPending || isDeleteWireRecipientPending;

  async function handleConfirm() {
    try {
      if (isDelete) {
        await deleteWireRecipient();
      } else {
        await cancelWireRecipient();
      }
      showToast({
        type: 'success',
        data: {
          content: `Wire Recipient has been successfully ${isDelete ? 'deleted' : 'canceled'}`,
        },
      });
      setOpen(false);
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Typography variant="h6" component="h2">
          {isDelete ? 'Delete' : 'Cancel'} Wire Recipient?
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Are you sure you want to {isDelete ? 'delete' : 'cancel'} the "{name}"
          wire recipient?
        </Typography>
      </DialogContent>
      <DialogActions>
        <SVButton variant="tertiary" onClick={() => setOpen(false)}>
          Close
        </SVButton>
        <SVButton variant="error" isLoading={isLoading} onClick={handleConfirm}>
          Confirm
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
